import {
  Accordion,
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Text,
  createStyles,
} from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import logo from "../../assets/img/minuslogo.svg";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  subheading: {
    fontWeight: 600,
    fontSize: "14px",
    color: "#262930",
    lineHeight: "21px",
    paddingTop: "16px",
  },

  data: {
    fontWeight: 550,
    fontSize: "14px",
    color: "#028ab0",
    lineHeight: "20px",
    paddingTop: "16px",
  },

  detailsText: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#262930",
    lineHeight: "22px",
    paddingTop: "16px",
  },
  underLinedHeading: {
    fontWeight: 600,
    fontSize: "16px",
    color: "#262930",
    lineHeight: "21px",
    textDecorationLine: "underline",
  },
  details: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#262930",
    lineHeight: "22px",
    paddingTop: "5px",
    width: "100%",
  },
  inplainNetwork: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingTop: "16px",
  },
  subHeadingBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  underLinedHeadingBox: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingTop: "16px",
  },
}));
interface Props {
  service?: any;
}

export const Details: React.FC<Props> = ({ service }) => {
  const { classes } = useStyles();
  const formatSideString = (str: string) => {
    if (str) 
      return (['Years', '$', '%'].find(excStr=> str.includes(excStr))?'': '$') + str;
    else 
      return '';
  }
  return (
    <>
      <Box>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <Box pr={8}>
              <img src={logo} alt="Svg" />
            </Box>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Text className={classes.underLinedHeading} pb={16}>
                  Details:
                </Text>
                {/* <Text className={classes.subheading}>
                  Family Active Coverage (OPEN ACCESS AETNA SELECT)
                </Text> */}
              </Box>
              {/* <Box pt={15}>
                <Divider />
              </Box>{" "} */}
              {service?.firstSection?.map((item: any, index: any) => (
                <>
                  <Box
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                      padding: "12px",
                      width: "100%",
                    }}
                  >
                    <Text className={classes.subheading} pb={16} pt={16}>
                      {item?.title}
                    </Text>
                    {item?.details?.map((detail: any, index: any) => (
                      <Text
                        className={classes.details}
                        fs="italic"
                        pt={16}
                        pb={16}
                      >
                        {detail}
                      </Text>
                    ))}
                  </Box>
                  <Box pt={15}>
                    <Divider pb={16} />
                  </Box>
                </>
              ))}
            </Box>
          </Box>
        </Box>
        {/* in plan network status */}
        <Box>
          <Box className={classes.inplainNetwork}>
            <Box pr={8}>
              <img src={logo} />
            </Box>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
              >
                <Text className={classes.underLinedHeading} pb={16}>
                  In Plan-Network status
                </Text>
                {service?.inNetSection?.map((item: any, index: any) => (
                  <>
                    <Box
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "4px",
                        padding: "12px",
                        marginBottom: "16px",
                      }}
                    >
                      <Box
                        className={classes.subHeadingBox}
                        sx={{ paddingBottom: "8px" }}
                      >
                        <Text className={classes.subheading}>
                          {item?.title} {item?.sideString ? ":" : ""}
                        </Text>
                        {item.sideString ? (
                          <Text className={classes.data}>
                            {formatSideString(item?.sideString)}
                          </Text>
                        ) : null}
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        {item?.details?.map((detail: any, index: any) => (
                          <Text className={classes.details} fs="italic" pt={16}>
                            {detail}
                          </Text>
                        ))}
                        {/* <Text fs={"italic"} className={classes.details}>{item?.details}</Text> */}
                      </Box>
                    </Box>
                    <Divider pb={16} pt={16} />
                  </>
                ))}
              </Box>
              {service?.inNetSection?.length == 0 && (
                <Text
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    padding: "12px",
                    borderRadius: "4px",
                  }}
                  className={classes.subheading}
                >
                  Family Not Covered
                </Text>
              )}
            </Box>
          </Box>
        </Box>
        {/* in plan network status */}
        <Box>
          <Box className={classes.underLinedHeadingBox}>
            <Box pr={8}>
              <img src={logo} />
            </Box>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
              >
                <Text className={classes.underLinedHeading} pb={16}>
                  Out of Plan-Network Status{" "}
                </Text>

                <Box
                // sx={{
                //   display: "flex",
                //   flexDirection: "row",
                //   justifyContent: "space-between",
                //   width: "100%",
                // }}
                >
                  {service?.outNetSection.map((item: any, index: any) => (
                    <>
                      <Box
                        bg={"white"}
                        mb={16}
                        sx={{
                          marginBottom: "16px",
                          padding: "12px",
                          borderRadius: "5px",
                        }}
                      >
                        <Box className={classes.subHeadingBox}>
                          <Text className={classes.subheading}>
                            {item?.title} {item?.sideString ? ":" : ""}
                          </Text>
                          {item.sideString ? (
                            <Text className={classes.data} weight={800}>
                              {formatSideString(item?.sideString)}
                            </Text>
                          ) : null}
                        </Box>
                        <Box
                          sx={{ display: "flex", flexDirection: "column" }}
                          pt={16}
                        >
                          {item?.details?.map((detail: any, index: any) => (
                            <Text
                              className={classes.details}
                              fs="italic"
                              pt={16}
                            >
                              {detail}
                            </Text>
                          ))}
                          {/* <Text fs={"italic"} className={classes.details}>{item?.details}</Text>  */}
                        </Box>
                      </Box>
                      <Box pb={16}>
                        <Divider sx={{ width: "100%" }} />
                      </Box>
                    </>
                  ))}
                  {service?.outNetSection?.length == 0 && (
                    <Text
                      sx={{
                        backgroundColor: "white",
                        width: "100%",
                        padding: "12px",
                        borderRadius: "4px",
                      }}
                      className={classes.subheading}
                    >
                      Family Not Covered
                    </Text>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
